/*jslint sloppy: true*/
/*global jQuery: true */

var Northstar = Northstar || {};

(function ($, window, document) {
  'use strict';

  // Define Northstar app
  Northstar.forms = {
    click: false,

    attach: function () {
      //console.log('Northstar.forms loaded');

      // Multiple-select for selects
        $('select:not(.drp-city-list)').each(Northstar.forms.createSelect);

      // Manually closing selects on body clicks for iOS
      if ($('select').length) {        
          $('.form-group-mobile select').on('touchend', Northstar.forms.closeSelect);
          $('.form-group-mobile select').on('touchstart', function () { Northstar.forms.click = true; });
          $('.form-group-mobile select').on('touchmove', function () { Northstar.forms.click = false; });       
        $('.ms-parent').on('touchend', function (e) { e.stopPropagation();});
      }

      // Validation
      $('form[data-validate]').attr('novalidate', true).on('submit', Northstar.forms.validate);

      // Dropdown forms: no autoclose, clear button, highlight state, reposition dropdown
      $('.form-dropdown .dropdown-menu').on('click touchstart', function (e) { e.stopPropagation(); });
      $('.form-dropdown .btn-clear').on('click touchstart', Northstar.forms.clearDropdownForm);
      $('.form-dropdown').on('hide.bs.dropdown', Northstar.forms.activeDropdownForm);
      $('.form-dropdown').on('shown.bs.dropdown', Northstar.forms.positionDropdownForm);
      $(window).on('load resize', function () {
        requestAnimationFrame(Northstar.forms.positionDropdownForm);
      });

      // Form search groups
      $('.form-group-search').each(Northstar.forms.searchGroup);

      // Checkbox groups, limiting max
      $('[data-single-checkbox]').each(Northstar.forms.limitCheckbox);

      // Checkbox check all
      $('[data-checkall-target]').each(Northstar.forms.checkAll);

      // Conditionally shown fields.
      $('[data-show-cond]').each(Northstar.forms.showCond);
    },

    closeSelect: function () {
      if (Northstar.forms.click === true) {
        $('body').trigger('click');
      }
    },

    createSelect: function () {
      var multiple = $(this).attr('multiple');
      if (!multiple) {
        $(this).multipleSelect({
          selectAll: false,
          single: true,
          width: '100%',
          allSelected: 'All selected', // can be translated by populating this
          countSelected: '# of % selected' // can be translated by populating this
        });
        if ($(this).data('placeholder')) {
          $(this).next().addClass('has-placeholder');
          $('.ms-choice > span', $(this).next())
            .addClass('placeholder')
            .text($(this).data('placeholder'));
        }
      }
      else {
        $(this).multipleSelect({
          selectAll: false,
          width: '100%',
          allSelected: 'All selected', // can be translated by populating this
          countSelected: '# of % selected' // can be translated by populating this
        });
        $(this).next().addClass('multiple');
      }
      if ($(".RegError").length > 0) { $(".RegError").hide(); }
    },

    validate: function (e, form) {
      form = (typeof form !== 'undefined') ? form : this;
      var formId = $(form).attr('id'),
        validateFields = $('[required]', form),
        errorMsgContainer = $('[data-error-form="' + formId + '"]').length ? $('[data-error-form="' + formId + '"]') : form,
        errorMsg = $('.form-error-msg', errorMsgContainer).remove(),
        errorText = [],
        emptyField = false,
        customValidate = null,
        validate = true;

      // Reset validation errors
      Northstar.forms.reset(form, false);

      validateFields.each(function () {
        var errorTarget = $(this).next().hasClass('ms-parent') ? $(this).next().find('.ms-choice > div') : $(this),
          fieldError = false;
        if (!$(this).val() || !$(this).val().length) {
          fieldError = true;
          emptyField = true;
        }

        // Custom validation function
        if (typeof $(this).data('validate') != 'undefined') {
          customValidate = Northstar.forms.validateFunc($(this), $(this).data('validate'));
          if (customValidate.valid === false) {
            fieldError = true;
            errorText.push(customValidate.msg);
          }
        }

        // Select values
        if ($(this).next().hasClass('ms-parent')) {
          if ($(this).multipleSelect('getSelects') === '') {
            fieldError = true;
          }
          else {
            fieldError = false;
          }
        }

        // Field error
        if (fieldError === true) {
          validate = false;
          errorTarget.addClass('form-error');
          $(this).on('blur.formValidate change.formValidate', function (e) {
            Northstar.forms.validate(e, form);
            $(this).off('blur.formValidate change.formValidate');
          });
        }
      });

      // Set error msg
      if (emptyField === true) {
        errorText.push('Please complete field(s) highlighted in red below');
      }

      if (validate === false) {
        $(errorMsgContainer).prepend($('<div class="form-error-msg">' + errorText.join('<br>') + '</div>'));
        $(errorMsgContainer).addClass('form-error');
        errorMsg.show();
        $(form).data('valid', false);
      }

      return validate;
    },

    validateFunc: function (el, type) {
      if (type == 'emails') {
         var emails = el.val(),
          validEmails = true,
          validRegExp = /^\w+((\+\w+)|(-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        if (emails !== '') {
          emails = emails.split(',');
          for (var n = 0; n < emails.length; n++) {
            var email = emails[n].trim();
            if (email !== '' && email.search(validRegExp) === -1) {
              validEmails = false;
              break;
            }
          }
        }
        return { 'valid': validEmails, 'msg': 'There is an error in email address format.'};
      }
    },

    reset: function (form, clearValues) {
      var formId = $(form).attr('id'),
        errorMsgContainer = $('[data-error-form="' + formId + '"]').length ? $('[data-error-form="' + formId + '"]') : form;
      $('.form-error-msg', errorMsgContainer).remove();
      if (typeof clearValues == 'undefined') {
        form.reset();
      }
      $('.form-error', form).removeClass('form-error');
      $(errorMsgContainer).removeClass('form-error');
      $(form).data('valid', true);
    },

    limitCheckbox: function () {
      var checkboxGroup = this;
      $('input[type="checkbox"]', checkboxGroup).on('change', function () {
        if ($(this).prop('checked')) {
          $('input[type="checkbox"]', checkboxGroup).not(this).prop('checked', false);
        }
      });
    },

    searchGroup: function () {
      var searchGroup = this;

      $('.form-group-search--filter input', searchGroup).on('keyup', function () {
        var keyword = $(this).val().toLowerCase();
        $('.form-group-search--scroll input', searchGroup).each(function () {
          var inputVal = $(this).val();
          if ($(this).attr('type') == 'checkbox') {
            inputVal = $(this).next().text();
          }
          if (keyword === '' || inputVal.toLowerCase().indexOf(keyword) > -1) {
            $(this).parent().show();
          }
          else {
            $(this).parent().hide();
          }
        });
      });
    },

    checkAll: function () {
      var checkAll = $(this),
        checkboxes = $(checkAll.data('checkall-target'));
      checkAll.on('click', function () {
        checkboxes.prop('checked', $(this).prop('checked'));
      });
      checkboxes.on('click', function () {
        checkAll.prop('checked', false);
      });
    },

    activeDropdownForm: function () {
      var dropdownForm = $(this);
      if ($('input:checked', dropdownForm).length) {
        dropdownForm.addClass('has-selected');
      }
      else {
        dropdownForm.removeClass('has-selected');
      }
    },

    clearDropdownForm: function (e) {
      e.preventDefault();
      var form = $(this).parentsUntil('.form-dropdown');
      $('input', form).prop('checked', false);
      $('input[type="text"]', form).val('').trigger('keyup');
    },

    positionDropdownForm: function () {
      var el = $('.form-dropdown .dropdown-menu.show');
      if (el.length) {
        el.removeAttr('style');
        var left = el.parent().position().left,
          dropdown = el.outerWidth(),
          width = el.closest('form').outerWidth(),
          formLeft = parseFloat(el.closest('.form-filters').css('paddingLeft'));
        left = left - formLeft;
        if (dropdown > width) {
          dropdown = width;
          el.css({maxWidth: dropdown});
        }
        if (left + dropdown > width) {
          el.css('marginLeft', -dropdown + (width - left));
        }
      }
    },

    showCond: function () {
      var el = $(this);
      $('#' + el.data('show-cond')).on('change', function () {
        el.fadeIn();
      });
    }
  };

  // Initialize our app on document ready
  $(document).ready(Northstar.forms.attach);

}(jQuery, this, this.document));
